import { useState, useEffect } from 'preact/hooks';
import { useErrorModalContextDispatch } from '../../storeProviders/errorModalStore';
const NoInternet = () => {
  const [checkOnlineStatus, setCheckOnlineStatus] = useState(false);
  const errorModalDispatch = useErrorModalContextDispatch();

  useEffect(() => {
    setCheckOnlineStatus(navigator.onLine);
    const onlineCallback = () => {
      errorModalDispatch({
        type: 'MODAL/CLOSE',
      });
    };
    const offlineCallback = () => {
      setCheckOnlineStatus((old) => !old);
    };

    window.addEventListener('online', onlineCallback);

    window.addEventListener('offline', offlineCallback);

    return () => {
      window.removeEventListener('online', onlineCallback);
      window.removeEventListener('offline', offlineCallback);
    };
  }, []);

  useEffect(() => {
    if (!navigator.onLine) {
      errorModalDispatch({
        type: 'MODAL/OPEN',
        payload: {
          title: 'No Internet',
          message: 'Please check your internet connection.',
          isRetryAllowed: true,
          retryButtonText: 'Try Again',
          onRetryClick: () => {
            setCheckOnlineStatus((old) => !old);
          },
          hideCloseButton: true,
        },
      });
    }
  }, [checkOnlineStatus]);

  return null;
};

export default NoInternet;



// WEBPACK FOOTER //
// ./components/salesApp/NoInternet.js